import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'registro',
    loadChildren: () =>
      import('./registro/registro.module').then((m) => m.RegistroPageModule),
  },
  {
    path: 'mis-actividades/:activity',
    loadChildren: () =>
      import('./mis-actividades/mis-actividades.module').then(
        (m) => m.MisActividadesPageModule
      ),
  },
  {
    path: 'necesitas-ayuda',
    loadChildren: () =>
      import('./necesitas-ayuda/necesitas-ayuda.module').then(
        (m) => m.NecesitasAyudaPageModule
      ),
  },
  {
    path: 'consentimiento-informado',
    loadChildren: () =>
      import('./consentimiento-informado/consentimiento-informado.module').then(
        (m) => m.ConsentimientoInformadoPageModule
      ),
  },
  {
    path: 'libros',
    loadChildren: () =>
      import('./libros/libros.module').then((m) => m.LibrosPageModule),
  },
  {
    path: 'calendario',
    loadChildren: () =>
      import('./calendario/calendario.module').then(
        (m) => m.CalendarioPageModule
      ),
  },
  {
    path: 'metas-personales',
    loadChildren: () =>
      import('./metas-personales/metas-personales.module').then(
        (m) => m.MetasPersonalesPageModule
      ),
  },
  {
    path: 'familias-fuertes',
    loadChildren: () =>
      import('./familias-fuertes/familias-fuertes.module').then(
        (m) => m.FamiliasFuertesPageModule
      ),
  },
  {
    path: 'progreso-actividades',
    loadChildren: () =>
      import('./progreso-actividades/progreso-actividades.module').then(
        (m) => m.ProgresoActividadesPageModule
      ),
  },  {
    path: 'videos',
    loadChildren: () => import('./videos/videos.module').then( m => m.VideosPageModule)
  },
  {
    path: 'recursos',
    loadChildren: () => import('./recursos/recursos.module').then( m => m.RecursosPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
